const getContractsFromList = (contractList: (GQL.IDeal | GQL.IDebt)[]) => {
  return contractList.map((contract) => {
    const { contracts, contractDetails } = contract;

    return contracts.map(
      (contractString) =>
        contractDetails?.find(
          (contractDetail) => contractString === contractDetail.contract
        ) || contractString
    );
  });
};

const getContractsFromDealOrDebt = (dealOrDebt: GQL.IDeal | GQL.IDebt) => {
  const { contracts, contractDetails } = dealOrDebt;

  return contracts.map(
    (contractString) =>
      contractDetails?.find(
        (contractDetail) => contractString === contractDetail.contract
      ) || contractString
  );
};

export { getContractsFromList, getContractsFromDealOrDebt };
